import {SubwaySearchItem} from '../@types';

export const getSubwayLineColor = (item: SubwaySearchItem) => {
  if (!item.line) {
    return '#b7b7b7';
  }

  const LINE_COLORS: {[key: string]: string} = {
    '1호선': '#0D347F',
    '2호선': '#33A23D',
    '3호선': '#FE5B10',
    '4호선': '#32A1C8',
    '5호선': '#8547CE',
    '6호선': '#865435',
    '7호선': '#54640D',
    '8호선': '#F51361',
    '9호선': '#AA9872',
    김포골드라인: '#AA9872',
    공항철도: '#0065B3',
    경원선: '#0D347F',
    경부선: '#0D347F',
    경인선: '#0D347F',
    장항선: '#0D347F',
    신림선: '#0D347F',
    안산선: '#32A1C8',
    과천선: '#32A1C8',
    분당선: '#F5A200',
    수인선: '#F5A200',
    경의선: '#77C4A3',
    중앙선: '#77C4A3',
    경춘선: '#0C8E72',
    경강선: '#003DA5',
    우이신설선: '#B7C452',
    경의중앙선: '#77C4A3',
    신분당선: '#971F2D',
    인천선: '#DBA829',
    인천1호선: '#6496df',
    인천2호선: '#FFB850',
    의정부경전철: '#E78522',
    용인에버라인: '#6FB26C',
    에버라인: '#6FB26C',
    자기부상: '#E9945A',
    자기부상철도: '#E9945A',
    동해선: '#72c9f0',
    서해선: '#8cc440',
    부산김해경전철: '#a743cd',
    수인분당선: '#fcd205',
    부산광역시_1호선: '#F06A00',
    부산광역시_2호선: '#81BF48',
    부산광역시_3호선: '#BB8C00',
    부산광역시_4호선: '#217DCB',
    광주광역시_1호선: '#009088',
    대구광역시_1호선: '#d93f5c',
    대구광역시_2호선: '#00aa80',
    대구광역시_3호선: '#ffb100',
    대전광역시_1호선: '#007448',
  };

  let line = item.line;

  if (item.organization !== '수도권') {
    switch (line) {
      case '1호선':
      case '2호선':
      case '3호선':
      case '4호선':
        line = item.organization + '_' + line;
    }
  }

  return LINE_COLORS[line] ?? '#b7b7b7';
};
